export { default } from './IntersectionObserver';
export { parseRootMargin } from './utils';


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/@researchgate/react-intersection-observer/lib/es/index.js
// module id = 360
// module chunks = 0